var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSaveColor(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 18,
    viewBox: "0 0 19 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.720736 2.65259C0.886556 1.23482 2.0878 0.165894 3.51524 0.165894H14.2579C14.44 0.165894 14.6159 0.232154 14.7527 0.352304L17.5132 2.77609C18.1338 3.321 18.4766 4.11597 18.447 4.94132L18.103 14.5147C18.0498 15.994 16.8351 17.1659 15.3548 17.1659H3.34454C2.01492 17.1659 0.892386 16.1779 0.723536 14.8591C0.227046 10.9809 0.205656 7.05659 0.659846 3.17317L0.720736 2.65259ZM3.51524 1.66589C2.84882 1.66589 2.288 2.16494 2.21058 2.82685L2.1497 3.34742C1.70968 7.10959 1.7304 10.9114 2.2114 14.6686C2.2844 15.2388 2.7697 15.6659 3.34454 15.6659H3.98163V11.4159C3.98163 10.4494 4.76513 9.66589 5.73163 9.66589H12.7316C13.6981 9.66589 14.4816 10.4494 14.4816 11.4159V15.6659H15.3548C16.0277 15.6659 16.5798 15.1332 16.604 14.4608L16.948 4.88746C16.9614 4.5123 16.8056 4.15094 16.5235 3.90326L13.9816 1.67139V4.01587C13.9816 4.98236 13.1981 5.76587 12.2316 5.76587H6.23163C5.26513 5.76587 4.48163 4.98236 4.48163 4.01587V1.66589H3.51524ZM5.98163 1.66589V4.01587C5.98163 4.15394 6.09356 4.26587 6.23163 4.26587H12.2316C12.3697 4.26587 12.4816 4.15394 12.4816 4.01587V1.66589H5.98163ZM12.9816 15.6659H5.48163V11.4159C5.48163 11.2778 5.59356 11.1659 5.73163 11.1659H12.7316C12.8697 11.1659 12.9816 11.2778 12.9816 11.4159V15.6659Z",
    fill: "#5FB531"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSaveColor);
export default __webpack_public_path__ + "static/media/saveColor.077aafa5a434b9c95cf63380a44b8b89.svg";
export { ForwardRef as ReactComponent };